module.exports = __webpack_public_path__ + "img/Video.09e5af89.svg";